import PurchaseBar from '../purchase-bar';
import SubscriptionGalleryHandler from '../shared/above-the-fold/subscription-gallery-handler';
import QuantityHandler from '../shared/above-the-fold/quantity-handler';
import SubscriptionHandler from '../shared/product/subscription-handler';
import AboveTheFoldSelectors from '../shared/above-the-fold/selectors';
import AddToCartHandler from '../shared/product/add-to-cart-handler';
import GalleryPopup from '../shared/above-the-fold/gallery-popup';
import OutOfStockSubscriptionHandler from '../shared/above-the-fold/out-of-stock-subscription-handler';
import { MEDIA_SELECTOR } from '../classnames/above-the-fold-gallery';
import ProductFlavorManager from './product-flavor-manager';
import VariantSelectDropdown from './variant-select-dropdown';
import { SELECTORS } from './constants';
import { HIDDEN } from '../classnames/design-system';

export default class AboveTheFold {
  constructor(container) {
    this.container = container;
    this.outOfStock = container.dataset.outOfStock === 'true';

    const galleryActiveElements = [...container.querySelectorAll(`.${MEDIA_SELECTOR}`)];
    const variantSwitcher = container.querySelector(`.${SELECTORS.VARIANT_SWITCHER}`);
    const isActiveContainer = !container.classList.contains(HIDDEN);

    this.galleryPopup = new GalleryPopup(galleryActiveElements, null, container);
    this.containers = container ? [container] : [];
    this.selectors = new AboveTheFoldSelectors(container);
    this.productFlavorManager = new ProductFlavorManager(container);
    this.variantDropdown = new VariantSelectDropdown(container, variantSwitcher, isActiveContainer);
    this.addToCartHandler = new AddToCartHandler(this.selectors, this.containers);
    this.quantityHandler = new QuantityHandler(this.containers);
    this.subscriptionHandler = new SubscriptionHandler(container);
    this.subscriptionGalleryHandler = new SubscriptionGalleryHandler(this.containers);
    this.outOfStockSubscriptionHandler = new OutOfStockSubscriptionHandler(container);
    this.purchaseBar = new PurchaseBar(container);
  }

  initializeEventListeners = () => {
    this.productFlavorManager.initializeEventListeners();

    if (this.outOfStock) {
      this.outOfStockSubscriptionHandler.initialize();
      this.galleryPopup.initializeEventListeners();
      this.subscriptionGalleryHandler.initializeEventListeners();

      return;
    }

    this.quantityHandler.initializeEventListeners();
    this.subscriptionHandler.initializeEventListeners();
    this.subscriptionGalleryHandler.initializeEventListeners();
    this.addToCartHandler.initializeEventListeners();
    this.galleryPopup.initializeEventListeners();
    this.variantDropdown.initializeEventListeners();
    this.purchaseBar.initializeEventListeners();
  };
}
